export const fetchSubscription = (state, subscription) => {
  state.subscription = subscription;
};

const SubscriptionMutation = {
  fetchSubscription
};

export default SubscriptionMutation;
